import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';

import {
	GenerateCellInfoRequest
} from '../requests/CellInfoRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_TEMPLATES = 'GET_TEMPLATES';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const ProcessFile = (inputType, type, sites) => async (dispatch) => {
	await GenerateCellInfoRequest(inputType, type, sites).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const GenerateCellInfo = (inputType, type, sites) => async (dispatch) => {
	if (inputType === 'file') {
		await UploadFile(sites).then(response => {
			dispatch(ProcessFile(inputType, type, response.data));
		}).catch((error) => {
			if (error) {
				dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
			}
		});
	} else {
		await GenerateCellInfoRequest(inputType, type, sites).then(response => {
			dispatch(DownloadFile(response.data));
		}).catch((error) => {
			if (error) {
				dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
			}
		});
	}
};
